module.exports = __webpack_public_path__ + "img/logo_color_collapsed.3f71dbd1.svg";